// extracted by mini-css-extract-plugin
module.exports = {"banner":"mBanner_banner__1yDr1","container":"mBanner_container__HedUZ","custom-dot":"mBanner_custom-dot__QS3HY","mActivity-time":"mBanner_mActivity-time__fApiU"};